import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useCountdown } from '../hooks/useCountdown';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(3599);
  return <section id="pricing-section" className="py-24 px-4 relative" data-id="element-170">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#39FF14]/10 via-transparent to-transparent -z-10" data-id="element-171"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-panel neon-box-green rounded-3xl p-8 md:p-16 relative overflow-hidden" data-id="element-173">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-[#39FF14] to-transparent" data-id="element-174"></div>

          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-175">
            El conocimiento que adquieras hoy definirá las decisiones que tomes
            mañana. Inversión mínima para un impacto de por vida en tus hábitos.
          </p>

          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-176">
            <span className="text-2xl text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-177">
              Valor regular: $47 USD
            </span>
            <span className="text-xl text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-178">
              Precio de lanzamiento: $19 USD
            </span>
            <div className="flex items-baseline gap-4" data-id="element-179">
              <span className="text-xl font-bold" data-id="element-180">Precio HOY:</span>
              <span className="text-6xl md:text-8xl font-black neon-text-green" data-id="element-181">
                $6.39
              </span>
              <span className="text-2xl text-[#39FF14] font-bold" data-id="element-182">USD</span>
            </div>
            <span className="text-sm text-gray-500 mt-1" data-id="element-183">Pago único</span>
          </div>

          <div id="pricing-cta" className="space-y-6" data-id="element-184">
            <CTAButton text="SÍ, QUIERO SER UN TEEN PRO — ACCESO INMEDIATO" onClick={() => {
            trackAddToCart();
            window.open('https://claridaddiaria.com/cart/43074986639426:1', '_blank');
          }} className="w-full md:w-auto" data-id="element-185" />

            <div className="flex items-center justify-center gap-2 text-red-400 font-mono font-bold" data-id="element-186">
              <span data-id="element-187">La oferta expira en:</span>
              <span className="bg-red-950/50 px-3 py-1 rounded border border-red-500/30" data-id="element-188">
                {hours}:{minutes}:{seconds}
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}